<style lang="scss" scoped>
  @import '../../../sass/variables';

  .card-with-circle-header {
    margin-top: 20px;
    margin-bottom: 33px;

    .card-header {
      background-color: transparent;
      padding-bottom: 0px;

      .card-list {
        margin-top: -46px;
        margin-bottom: 20px;

        .card-circle-header {
          max-width: 42px;
          height: 42px;
          margin-left: auto;
          margin-right: auto;
          position: relative;
          z-index: 2;
          width: 100%;

          &__circle-title {
            height: 100%;
            background-color: $gray-dark;
            width: 100%;
            font-size: 17px;
            text-align: center;
            color: $white-gray;
            font-family: Montserrat;
            font-weight: 700;
            line-height: 30px;
            padding-top: 5px;
            border-radius: 50%;
          }
        }
      }
    }
  }
</style>

<template>
  <form @submit.prevent="saveAccount()">
    <hr class="first-divider">
    <div class="form-group row">
      <div class="col-md-12">
        <h3>{{ __('Empresa') }}</h3>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <label>{{ __('Nome da Empresa') }}</label>
        <input
          class="form-control"
          type="text"
          name="name"
          v-model="account.name"
          :placeholder="__('Digite o nome da sua empresa')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('name')"
        >{{ account.errors.get('name') }}</span>
      </div>
      <div class="col-md-6">
        <label>{{ __(cnpj ? 'CNPJ' : 'CPF / CNPJ') }}</label>
        <input
          class="form-control"
          type="text"
          name="document"
          v-model="account.document"
          :placeholder="__('Digite seu ' + cnpj ? 'CNPJ' : 'CPF / CNPJ')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('document')"
        >{{ account.errors.get('document') }}</span>
      </div>
    </div>
    <hr>
    <div class="form-group row">
      <div class="col-md-12">
        <h3>{{ __('Responsável') }}</h3>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <label>{{ __('Responsável') }}</label>
        <input
          class="form-control"
          type="text"
          name="contact"
          v-model="account.contact"
          :placeholder="__('Nome completo do responsável pela empresa')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('contact')"
        >{{ account.errors.get('contact') }}</span>
      </div>
      <div class="col-md-6">
        <label>{{ __('E-mail') }}</label>
        <input
          class="form-control"
          type="email"
          name="email"
          v-model="account.email"
          :placeholder="__('E-mail do responsável pela empresa')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('email')"
        >{{ account.errors.get('email') }}</span>
      </div>
    </div>
    <div class="form-group row border-bottom-checkout">
      <div class="col-md-6">
        <label>{{ __('CPF do Responsável') }}</label>
        <Cleave
          class="form-control"
          type="text"
          :options="cleave.cpf.options"
          name="contact_document"
          v-model="account.contact_document"
          :placeholder="__('CPF do responsável pela empresa')"
        /><span
          class="form-text text-danger"
          v-show="account.errors.has('contact_document')"
        >{{ account.errors.get('contact_document') }}</span>
      </div>
      <div class="col-md-6">
        <label>{{ __('Telefone') }}</label>
        <Cleave
          class="form-control"
          type="text"
          :options="cleave.phone.options"
          name="contact_phone"
          v-model="account.contact_phone"
          :placeholder="__('Telefone do responsável')"
        /><span
          class="form-text text-danger"
          v-show="account.errors.has('contact_phone')"
        >{{ account.errors.get('contact_phone') }}</span>
      </div>
    </div>
    <hr>
    <div class="form-group row">
      <div class="col-md-12">
        <h3>{{ __('Endereço') }}</h3>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4">
        <label>{{ __('CEP') }}</label>
        <Cleave
          class="form-control"
          type="text"
          :options="cleave.cep.options"
          v-model="account.address.postalcode"
          :placeholder="__('Digite para pesquisar')"
        /><span
          class="form-text"
          v-show="account.errors.has('address.postalcode')"
        >{{ account.errors.get('address.postalcode') }}</span><span
          class="text-danger"
          v-if="postalCodeFail"
        >{{ __('CEP não encontrado, preencha as informações.') }}</span><i
          class="fa fa-spin fa-circle-o-notch"
          v-if="searching"
        />
      </div>
      <div class="col-md-8">
        <label>{{ __('Rua') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.street"
          :placeholder="__('Digite a Rua')"
          :readonly="! postalCodeFail && !postalCodeGeral"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.street')"
        >{{ account.errors.get('address.street') }}</span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4">
        <label>{{ __('Número') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.number"
          :placeholder="__('Número')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.number')"
        >{{ account.errors.get('address.number') }}</span>
      </div>
      <div class="col-md-8">
        <label>{{ __('Complemento') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.complement"
          :placeholder="__('Complemento')"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.complement')"
        >{{ account.errors.get('address.complement') }}</span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4">
        <label>{{ __('Bairro') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.district"
          :placeholder="__('Digite o Bairro')"
          :readonly="! postalCodeFail && !postalCodeGeral"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.district')"
        >{{ account.errors.get('address.district') }}</span>
      </div>
      <div class="col-md-4">
        <label>{{ __('Cidade') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.city"
          :placeholder="__('Digite a Cidade')"
          :readonly="! postalCodeFail"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.city')"
        >{{ account.errors.get('address.city') }}</span>
      </div>
      <div class="col-md-4">
        <label>{{ __('Estado') }}</label>
        <input
          class="form-control"
          type="text"
          v-model="account.address.state"
          :placeholder="__('Digite o Estado')"
          :readonly="! postalCodeFail"
        ><span
          class="form-text text-danger"
          v-show="account.errors.has('address.state')"
        >{{ account.errors.get('address.state') }}</span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6 align-self-center">
        <BFormCheckbox
          class="circle-purple-checkbox float-left"
          type="checkbox"
          v-model="account.terms"
          value="true"
        >
          <label>
            {{ __('Eu aceito os') }}

            <u><a
              class="hyperlink"
              href="https://salesflowcrm.movidesk.com/kb/article/405957/termos-de-uso"
              target="_blank"
            >{{ __('termos de uso.') }}</a></u>
          </label><span
            class="form-text text-danger"
            v-show="account.errors.has('terms')"
          >{{ account.errors.get('terms') }}</span>
        </BFormCheckbox>
      </div>
      <div class="col-md-6">
        <BButton
          class="float-right"
          variant="primary"
          type="submit"
        >
          <span>{{ __('Continuar') }}</span>
        </BButton>
      </div>
    </div>
  </form>
</template>
<script>
import { BButton, BFormCheckbox } from 'bootstrap-vue';
import Cleave from 'vue-cleave-component';

export default {
  components: {
    BButton,
    BFormCheckbox,
    Cleave,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
    cnpj: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data () {
    return {
      searching: false,
      loading: false,
      postalCodeFail: false,
      postalCodeGeral: false,
      account: new BulldeskForm({
        address: {
          postalcode: '',
        },
      }),
      cleave: {
        creditCard: {
          options: {
            numericOnly: true,
            creditCard: true,
            delimiter: '.',
          },
        },
        phone: {
          options: {
            numericOnly: true,
            blocks: [0, 2, 4, 5],
            delimiters: ['(', ') ', '-'],
          },
        },
        cep: {
          options: {
            numericOnly: true,
            blocks: [2, 3, 3],
            delimiters: ['.', '-'],
          },
        },
        cpf: {
          options: {
            numericOnly: true,
            blocks: [3, 3, 3, 2],
            delimiters: ['.', '.', '-'],
          },
        },
      },
    };
  },

  watch: {
    'account.address.postalcode': function (postalcode) {
      if (this.loading || postalcode.length < 8) {
        return;
      }

      this.getAddressByApi(postalcode);
    },
  },

  created () {
    this.getDetails();

    Echo.channel(`tenant.${this.user.account}`)
      .listen('.contract_signed', (e) => {
        console.log(e);

        this.getDetails();
      });
  },

  methods: {
    getDetails () {
      this.$http.get('/billing/details')
        .then(({ data }) => {
          const { tenant } = data;

          tenant.address = _.merge(
            {
              postalcode: '',
              street: '',
              number: '',
              district: '',
              complement: '',
              city: '',
              state: '',
            },
            tenant.address,
          );

          this.account = new BulldeskForm(data.tenant);

          Vue.nextTick(() => {
            this.loading = false;
          });
        });
    },
    getAddressByApi (postalcode) {
      this.searching = true;

      this.$http.get(`/address/${postalcode}`)
        .then(({ data }) => {
          this.account.address.postalcode = data.postalcode;
          this.account.address.city = data.city;
          this.account.address.street = data.street;
          this.account.address.district = data.district;
          this.account.address.state = data.state;

          this.postalCodeFail = false;
          this.postalCodeGeral = false;

          if (this.account.address.street == '' || this.account.address.district == '') {
            this.postalCodeGeral = true;
          }
        })
        .catch(() => {
          this.postalCodeFail = true;
        })
        .finally(() => {
          this.searching = false;
        });
    },

    saveAccount () {
      this.account.busy = true;

      this.account.cnpjRequired = this.cnpj;

      Http.put('/billing/account', this.account)
        .then(() => {
          Bus.$emit('formEditAccountSave');
        });
    },
  },
};
</script>
